<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>{{ mdiCogBox }}</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        :to="item.to"
        @click="clickItem(item)"
      >
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mdiCogBox } from '@mdi/js';
import { mapGetters } from 'vuex';

export default {
  name: 'SettingsMenu',
  module: 'menu',
  data() {
    return {
      // icons
      mdiCogBox,
    };
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    locale() {
      return this.$i18n.availableLocales.find((l) => l !== this.$i18n.locale);
    },
    items() {
      const { locale, switchLocale } = this;
      const result = [{
        click: switchLocale,
        param: locale,
        title: this.$$t(`switch-to-${locale}`),
      }];
      if (this.isLoggedIn) {
        result.unshift({
          to: { name: 'membership-EditProfile' },
          title: this.$$t('profile'),
        });
        result.unshift({
          to: { name: 'auth-Logoff' },
          title: this.$$t('logoff'),
        });
      }
      return result;
    },
  },
  methods: {
    clickItem(item) {
      if (item.click) {
        item.click(item.param);
      }
    },
    /** Method used to switch the locale
     */
    switchLocale(locale) {
      this.$root.$i18n.locale = locale;
    },
  },
};
</script>
